export default __webpack_public_path__ + "static/media/img-historia.a79f3940.jpg";